jQuery(document).ready(function() {
    if (!is_dev) {
        return;
    }
    // add_invoice();
});

function load_contact_and_company_selectors(elm, vars) {
    const $ = jQuery.noConflict();
    let loadContactSelector;
    let loadCompanySelector;
    const this_entity_ajax = {};

    const changeIdentifier = 'change.contactAndCompanySelectors';

    const isExisting = vars && vars.existing;
    const allowEmptyContact = vars && vars.allowEmptyContact;

    const setclientId = function(client_id) {
        if (client_id === undefined) {
            client_id = null;
        }
        const input = elm.find('input[name="client_id"]');
        console.log({ input });
        if (input.is('[disabled]')) {
            return;
        }
        if (input.length > 0) {
            input.val(client_id);
        }
    };

    loadContactSelector = function(val) {
        if (!isExisting) {
            setclientId();
        }
        elm.find('[data-contact-selector]').removeClass('has-special-selector').contactSelector(val).unbind(changeIdentifier).bind(changeIdentifier,  function() {
            const v = $(this).val();
            if(this_entity_ajax.contact !== undefined) {
                this_entity_ajax.contact.abort();
            }

            if (isExisting) {
                if (!(parseInt(elm.find('[data-company-selector]').val()) > 0)) {
                    try {
                        const select = $(this);
                        const option = select.find('option[value="' + v + '"]');
                        const contact = JSON.parse(decodeURIComponent(atob(option.attr('data-object'))));
                        setclientId(contact.client_id);
                    } catch (e) {
                        setclientId(null);
                    }
                }
                return;
            }
            if(parseInt(v) > 0) {
                this_entity_ajax.contact = $.ajax({
                    url: "/ajax/getContacts",
                    data: {id: v},
                    success: function(data) {
                        const contact = data[0];
                        if(contact.company_id !== null) {
                            const selected_company = parseInt(elm.find('[data-company-selector]').val());
                            if(selected_company.toString() !== contact.company_id.toString()) {
                                // Contact belongs to other company, see if he is supervisor there
                                const companies = contact.company_ids;
                                if(companies.indexOf(selected_company) === -1) {
                                    const new_company_id = contact.company_id;
                                    loadCompanySelector(new_company_id);
                                }
                            }
                        } else {
                            loadCompanySelector(null);
                            setclientId(contact.client_id);
                        }
                    }
                });
            }
        });
    }.bind([elm, this_entity_ajax, loadCompanySelector]);
    loadContactSelector((vars !== undefined && vars.values && vars.values.contact_id) ? vars.values.contact_id : elm.find('[data-contact-selector]').attr('data-current-value'));

    loadCompanySelector = function(val) {
        if (!isExisting) {
            setclientId(null);
        }
        elm.find('[data-company-selector]').removeClass('has-special-selector').companySelector(val).unbind(changeIdentifier).bind(changeIdentifier, function() {
            const v = $(this).val();
            if(this_entity_ajax.company !== undefined) {
                this_entity_ajax.company.abort();
            }



            // console.log({ isExisting })
            if (isExisting) {
                try {
                    const select = $(this);
                    const option = select.find('option[value="' + v + '"]');
                    const company = JSON.parse(decodeURIComponent(atob(option.attr('data-object'))));
                    setclientId(company.client_id);
                } catch (e) {
                    setclientId(null);
                }
                return;
            }
            if(parseInt(v) > 0) {
                invoice_entity_ajax.company =  $.ajax({
                    url: "/ajax/getCompanies",
                    data: {id: v},
                    success: function(data) {
                        const company = data[0];
                        const chosen_contact_id = parseInt(elm.find('[data-contact-selector]').val());
                        const contacts = company.these_contacts;

                        if (!allowEmptyContact) {
                            if (isNaN(chosen_contact_id) || chosen_contact_id < 1 || (chosen_contact_id > 0 && contacts.indexOf(chosen_contact_id) === -1)) {
                                if (company.contact_person_id) {
                                    loadContactSelector(company.contact_person_id);
                                } else if (contacts.length > 0) {
                                    loadContactSelector(contacts[0]);
                                } else {
                                    loadContactSelector(null);
                                }
                            }
                        }

                        setclientId(data[0].client_id);
                        if ((!vars || !vars.existing) && data[0].default_payment_condition_id) {
                            setPaymentConditionId(elm, data[0].default_payment_condition_id);
                        }
                    }
                });
            }
        });
    }.bind([elm, this_entity_ajax, loadContactSelector]);
    loadCompanySelector((vars !== undefined && vars.values && vars.values.company_id) ? vars.values.company_id : elm.find('[data-company-selector]').attr('data-current-value'));

}
function setPaymentConditionId(elm, id) {
    if (parseInt(id) >= 0) {
        elm.find('#payment_condition_id').val(id);
    } else {
        elm.find('#payment_condition_id').children().removeAttr('selected');
    }
}
